// extracted by mini-css-extract-plugin
module.exports = {"padding":"Container_padding__YNPcs","root":"Container_root__1UMcZ"};